// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3O6zF","input":"styles_input__2-Np8"};